import { z } from "zod";
import {
  baseProductSchema,
  defaultBaseProductValues,
} from "./base-product.schema";

export const createProductSchema = baseProductSchema;

export const defaultCreateProductValues: CreateProductForm = defaultBaseProductValues;

export type CreateProductForm = z.infer<typeof createProductSchema>;
